<template>	
	<div class="map-file">
	  <!-- 地图文件管理 -->
	  <el-row :gutter="24">		  
		<el-col :span="6" class="shadow">
		  <!-- 车辆列表部分 -->
		  <div>
			  <!-- 查找参数区 -->
			  <div class="filter-container">
				  <el-input placeholder="请输入机器人ID" v-model="listQueryCar.params.id" style="width: 360px" class="filter-item"></el-input>
				  <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilterCar(true)">
					搜索
				  </el-button>
			  </div>
			  <!-- 数据列表区 -->
			  <el-table
				:data="listDataCar"
				v-loading="listLoadingCar"
				border
				highlight-current-row
				style="width: 100%;align: center;">
				<el-table-column prop="index" label="序号" width="60px" align="center">
				</el-table-column>
				<el-table-column prop="name" label="机器人名称" align="center">
				</el-table-column>
				<el-table-column prop="operator" label="操作" align="center">
				  <template v-slot:="{row,$index}">
					<el-button type="primary" size="mini" @click="handleShowMapPackList(row)">
					  查看地图包
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
	      
			  <!-- 分页栏 -->
			  <pagination :total="totalCountsCar" :page="listQueryCar.pageIndex" layout='sizes,prev, pager, next'
				@pagination="handlePageChangeCar" small :pager-count="5" >
			  </pagination>
			</div>
		</el-col>
		
		<!-- 文件列表部分 -->
	    <el-col :span="18" class="shadow">
	      <div style="100%">
			  
	        <!-- 展示车辆ID -->
	        <div class="car-id">
	            地图文件所属机器人ID:
	            <el-input
	              style="width: 310px"
	              placeholder=""
	              v-model="curCarId"
	              :disabled="true">
	            </el-input>
				<el-input style="display: none;"  v-model="curCarName"> </el-input>
	        </div>
			
			<el-col :span="14" >
					<!-- 数据列表区 -->
					<el-table
					  :data="listDataMapPack.slice((currentMapPackPage - 1) * mapPackPageSize,currentMapPackPage * mapPackPageSize)"
					  v-loading="listLoadingMapPack"
					  border
					  highlight-current-row
					  style="width: 100%;align: center;">
					  <el-table-column prop="index" label="序号" width="60px" align="center">
					  </el-table-column>
					  <el-table-column prop="mapPackName" label="地图包名称" width="150px" align="center">
					  </el-table-column>
					  <el-table-column prop="mapPackNum" label="地图包编号" width="180px" align="center">
					  </el-table-column>
						<el-table-column prop="mapPackStatusStr" label="地图包状态" width="150px" align="center">
						</el-table-column>
					  <el-table-column prop="operator" label="操作" align="center">
					    <template v-slot:="{row,$index}">
					      <el-button-group>
							<el-button type="primary" size="mini" style="margin-left:5px" @click="handleFilterTaskFile(row)">
							  删除任务
							</el-button>  
							<el-button type="primary" size="mini" style="margin-left:5px" @click="handleFilterTrajFile(row.mapPackName,row.mapPackNum)">
							  删除轨迹
							</el-button>					       
							<el-button type="primary" size="mini" style="margin-left:5px" @click="handleDeleteMapFolder(row)">
							  删除云文件
							</el-button>
							<el-button type="primary" size="mini" @click="handleTrackMapDelete(0,row)">
							  删除地图
							</el-button>
					      </el-button-group>
					    </template>
					  </el-table-column>
					</el-table>
					
					<!-- 分页栏 -->
					<pagination :total="mapPackTotal" layout='sizes,prev, pager, next' v-if="mapPackTotal!=0"
					  @pagination="handlePageChangeMapPack">
					</pagination>
				</el-col>
				
				<el-col :span="10" >
					<!-- 数据列表区 -->
					<el-table
					  :data="listDataTrack.slice((currentTrackPage - 1) * trackPageSize,currentTrackPage * trackPageSize)"
					  v-loading="listLoadingTrack"
					  border
					  highlight-current-row
					  style="width: 100%;align: center;">
					  <el-table-column prop="index" label="序号" width="60px" align="center">
					  </el-table-column>
					  <el-table-column prop="mapPackName" label="差分轨迹名称" width="160px" align="center">
					  </el-table-column>
					  <el-table-column prop="mapPackNum" label="差分轨迹编号" width="180px" align="center">
					  </el-table-column>
					  <el-table-column prop="operator" label="操作" align="center">
					    <template v-slot:="{row,$index}">
								<el-button type="primary" size="mini" style="margin-left:5px" @click="handleFilterTaskFile(row)">
								  删除任务
								</el-button>  
					      <el-button type="primary" size="mini"  @click="handleTrackMapDelete(0,row)">
					        删除
					      </el-button>
					    </template>
					  </el-table-column>
					</el-table>
					
					<!-- 分页栏 -->
					<pagination :total="trackTotal" layout='sizes,prev, pager, next' v-if="trackTotal!=0"
					  @pagination="handlePageChangeTrack">
					</pagination>
				</el-col>
	      </div>
	    </el-col>
	  </el-row>

	<!-- 查看轨迹列表弹出框 -->
	<el-dialog :title="TrackMapDialogTitle" :visible.sync="TrackMapkDialogVisible" top="8vh" width="60%"> 
	  <div>
	    <!-- 数据列表区 -->
	    <el-table
	      :data="listDataTrackMap.slice((currentTrackMapPage - 1) * trackMapPageSize,currentTrackMapPage * trackMapPageSize)"
	      v-loading="listLoadingTrackMap"
	      border
	      highlight-current-row
	      style="width: 100%;align: center;">
	      <el-table-column prop="index" label="序号" width="60px" align="center"> </el-table-column>
	      <el-table-column prop="mapPackName" label="轨迹名称" align="center"></el-table-column>
		  <el-table-column prop="mapPackNum" label="轨迹编号" align="center"></el-table-column>
		  <el-table-column  label="执行操作" align="center">
			<template v-slot:="{row,$index}">
				<el-button type="danger" size="mini" @click="handleTrackMapDelete(1,row)">
					删除
				</el-button>
			</template>	
		  </el-table-column>
	    </el-table>
	    
	    <!-- 分页栏 -->
	    <pagination :total="trackMapTotal"
	      @pagination="handleTrackMapChangeFile">
	    </pagination>
	  </div>
	
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="TrackMapkDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="TrackMapkDialogVisible = false">确 定</el-button>
	  </span>
	</el-dialog>		
			
	<!-- 查看任务弹出框 -->
	<el-dialog :title="taskDialogTitle" :visible.sync="taskDialogVisible" top="8vh" width="60%"> 
	  <div>
	    <!-- 数据列表区 -->
	    <el-table
	      :data="listTaskFile.slice((currentTaskPage - 1) * taskPageSize,currentTaskPage * taskPageSize)"
	      v-loading="listLoadingTask"
	      border
	      highlight-current-row
	      style="width: 100%;align: center;">
	      <el-table-column prop="index" label="序号" width="60px" align="center"> </el-table-column>
	      <el-table-column prop="missionName" label="任务名称" align="center"></el-table-column>
			<el-table-column prop="missionMap" label="地图名称" align="center"></el-table-column>
			<el-table-column prop="userName" label="创建人" align="center"></el-table-column>
			<el-table-column prop="missionFunc" label="执行操作" align="center">
				<template v-slot:="{row,$index}">
					<el-button type="danger" size="mini" @click="handleTaskDelete(row)">
						删除
					</el-button>
				</template>
			</el-table-column>		
	    </el-table>
	    
	    <!-- 分页栏 -->
	    <pagination :total="taskTotalNum"
	      @pagination="handleTaskChangeFile">
	    </pagination>
	  </div>
	
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="taskDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="taskDialogVisible = false">确 定</el-button>
	  </span>
	</el-dialog>	
	
  </div>	
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {carList} from '@/api/car'
	import {fileList,listMapPack,listTrajByCarMap,deleteMapOrTraj,deleteWork,deleteMapFolder} from '@/api/file'
	import {taskList} from '@/api/task'
	
	export default{
		data(){
			return{
				loginuser:this.$store.getters['user/userName'],
				// 车辆列表部分
				listLoadingCar: true,
				listDataCar: [],
				totalCountsCar: 0,
				listQueryCar: {
				  entityId: this.$store.getters['user/entityId'],
				  pageIndex: 1,
				  pageSize: 10,
				  params: {
				    id: undefined
				  },
				  fuzzySearch: true
				},
				
				//地图包列表部分
				curCarId:undefined,
				curCarName:'',
				listLoadingMapPack: false,
				listDataMapPack: [],
				currentMapPackPage: 1,//当前地图包列表页码
				mapPackPageSize: 10,//每页展示地图包数据条数
				mapPackTotal: 0,//地图包列表数据总条数					

				curMapPackName:undefined,//地图包名称-显示使用
				curMapPackNum:undefined,//地图包编号-显示以及查询文件使用

			
				//轨迹列表
				listLoadingTrackMap:false,
				TrackMapDialogTitle:'',
				listDataTrackMap:[],
				TrackMapkDialogVisible:false,
				currentTrackMapPage:1,
				trackMapPageSize:10,
				trackMapTotal:0,
				
				//差分轨迹
				listLoadingTrack:false,
				listDataTrack:[],
				currentTrackPage:1,
				trackPageSize:10,
				trackTotal:0,
				
					
				//任务列表弹出框相关
				curMapPackName:undefined,
				listLoadingTask: false,
				listTaskFile:[],
				taskDialogTitle:"",
				taskDialogVisible:false,
				currentTaskPage: 1,
				taskPageSize: 10,
				taskTotalNum: 0
				
			}
		},
		mounted(){
		    this.handleFilterCar()
		},
		components: {
		  Pagination
		},
		methods:{
			/**
			 * 请求车辆数据
			 */
			handleFilterCar(isNewSearch = false) {
			  //如果是“新搜索”（即非翻页，而是点击搜索按钮进行搜索）
			  if(isNewSearch) {
			    //页数修改1
			    this.listQueryCar.pageIndex = 1;
			    //清空地图包列表
			    this.clearMapPackList();
			  }
			
			  this.listLoadingCar = true
			  carList(this.listQueryCar, null).then(res => {
			    let data = res.pageData
			    this.totalCountsCar = data.totalCounts
				if(data.datas!=null && data.datas.length > 0){
					// 对后端数据进行解析
					this.listDataCar = data.datas.map((item,index) => {
					  return {
					    index: index+1,
					    id: item.id,
					    name: item.name
					  }
					})
				}
			    this.listLoadingCar = false
			  })
			},
			/**
			 * 处理小车列表翻页
			 */
			handlePageChangeCar(data) {
			  this.listQueryCar.pageIndex = data.page
			  this.listQueryCar.pageSize = data.limit
			  this.handleFilterCar()
			},
			/**
			 * 
			 * 展示当前车辆下地图文件
			 */
			handleShowMapPackList(row) {
			  this.listLoadingMapPack = true
			  this.listLoadingTrack = true
			  this.curCarId=row.id
			  this.curCarName = row.name
			  this.url = "";
			  this.listDataMapPack = []
			  this.listDataTrack = []
			  listMapPack(row.id).then(res => {
			    if(res.result === "1") {
			        let data = res.data;
					if(data!=null && data.length > 0){
						//由于后端是直接从FTP中获取文件夹列表，所以此处需要进行前端分页操作
						data.forEach((item,index) =>{
							var flag = item.flag
							var bean = {
								index: index+1,
								mapPackName: item.mapPackName,
								mapPackNum: item.mapPackNum,
								mapPackId:item.mapPackId,
								mapPackStatusStr:item.mapPackStatus == 1 ? '已删' :'正常',
								users:item.users,
								netPath:item.netPath
							}
							if(flag == 2){
								this.listDataTrack.push(bean)
							}else{
								this.listDataMapPack.push(bean)
							}
						})
					}
			    } else {
			      this.$message.error(res.message);
			    }
			    this.mapPackTotal = this.listDataMapPack.length;
			    this.listLoadingMapPack = false;
				
				this.trackTotal = this.listDataTrack.length
				this.listLoadingTrack = false;
			  })
			},
			clearMapPackList() {
			  this.curCarId = undefined;
			  this.curCarName = "";
			  this.url = "";
			  this.listDataMapPack = [];
			  this.mapPackTotal = this.listDataMapPack.length;
			},
			
			/**
			 * 处理地图/轨迹列表翻页
			 */
			handlePageChangeMapPack(data) {
			  this.currentMapPackPage = data.page;
			  this.mapPackPageSize = data.limit;
			},
			/**
			 *  处理差分轨迹列表翻页
			 */
			handlePageChangeTrack(data){
				this.currentTrackPage = data.page;
				this.trackPageSize = data.limit;
			},
			/**
			 * 关闭地图包目录文件
			 */
			closeFileDialog() {
			  this.curMapPackName = undefined;
			  this.curMapPackNum = undefined;
			  this.listDataFile = [];
			  this.mapOrTrajFileDialogVisable = false;
			},
			/**
			 * 处理地图包目录文件翻页
			 */
			handlePageChangeFile(data) {
			  this.currentFilePage = data.page;
			  this.filePageSize = data.limit;
			},
			/**
			 * 显示当前地图下轨迹文件
			 */
			handleFilterTrajFile(mapPackName,mapPackNum) {						
		
			  this.listDataTrackMap = [];
			  this.curMapPackName = mapPackName;
			  this.curMapPackNum = mapPackNum;
			  this.TrackMapDialogTitle = "当前机器人："+ this.curCarName +"; 当前地图："+this.curMapPackName+"["+ this.curMapPackNum+"]"  ;
			  this.TrackMapkDialogVisible = true;
			  this.listLoadingTrackMap = true	  
			  
			  listTrajByCarMap(this.curCarId,this.curMapPackNum).then(res =>{
				   if(res.result === "1") {
				        let data = res.data;
						if(data!=null && data.length > 0){
							//由于后端是直接从FTP中获取文件夹列表，所以此处需要进行前端分页操作
							data.forEach((item,index) =>{
								var flag = item.flag
								var bean = {
									index: index+1,
									mapPackName: item.mapPackName,
									mapPackNum: item.mapPackNum,
									mapPackId:item.mapPackId,
									mapPackStatusStr:item.mapPackStatus == 1 ? '已删' :'正常',
									users:item.users,
									netPath:item.netPath
								}
								this.listDataTrackMap.push(bean)
							})
						}
				   } else {
				     this.$message.error(res.message);
				   }
				   this.trackMapTotal = this.listDataTrackMap.length;
				   this.listLoadingTrackMap = false;
			  })
			},
			handleTrackMapChangeFile(data){
				this.currentTrackMapPage = data.page;
				this.trackMapPageSize = data.limit;
			},
			handleTrackMapDelete(flag,row){ 			
				this.$confirm('确定要删除吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'	
				}).then(() => {
					var netWork = row.netPath
					var id = row.mapPackId
					deleteMapOrTraj(id,netWork).then(res =>{
						 if(res.result==="1"){
							  this.$message.info(res.message)
						 }else{
							 this.$message.error(res.message) 
						 }
						 if(flag == 1){
							this.handleFilterTrajFile(this.curMapPackName,this.curMapPackNum)
						 }else{
							var carinfo = {
								id:this.curCarId,
								name:this.curCarName
							}
							this.handleShowMapPackList(carinfo) 
						 }
						
					})
				})
				
			},
			
			/**
			 * 查看当前车辆下任务列表
			 */
			handleFilterTaskFile(rowdata){
				this.listTaskFile = [];
				this.taskDialogVisible = true
				this.mapOrTrajFileDialogVisable = false
				this.psDialogVisible = false
				this.curMapPackName = rowdata.mapPackName;
				this.curMapPackNum = rowdata.mapPackNum;
				this.taskDialogTitle = "当前机器人："+ this.curCarName + "; 当前地图："+this.curMapPackName+"["+this.curMapPackNum+"]" ; 
				this.listLoadingTask = true
				taskList(this.curMapPackNum).then(res => {
				  if(res.result==="1"){
				    let data = res.data
					if(data != null && data.length > 0){
						 // 对后端数据进行解析
						 this.listTaskFile = data.map((item,index) => {
						   return {
						     index: index+1,
							 missionId:item.id,
						     missionName:item.missionName,
						 	 userName:item.userid,
						 	 missionMap:item.missionMap,
						 	 missionFunc:item.missionFunc,
						 	 missionItem:item,
						   }
						 })
					}
				  }else{
				      this.$message.error(res.message)
				  }
				  this.taskTotalNum = this.listTaskFile.length;
				  this.listLoadingTask = false
				})				
			},
			/**
			 * 处理任务列表翻页
			 */
			handleTaskChangeFile(data){
				this.currentTaskPage = data.page;
				this.taskPageSize = data.limit;
			},
			handleTaskDelete(row){
				this.$confirm('确定要删除吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'	
				}).then(() => {
					var id = row.missionId
					deleteWork(id).then(res =>{
						 if(res.result==="1"){
							  this.$message.info(res.message)
						 }else{
							 this.$message.error(res.message) 
						 }
						 var mapinfo = {
							 mapPackName:this.curMapPackName ,
							 mapPackNum:this.curMapPackNum
						 }
						 this.handleFilterTaskFile(mapinfo)
					})
				})
			},
			handleDeleteMapFolder(row){				
				this.$confirm('确定要删除吗？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'	
				}).then(() => {
					var mapPackNum = row.mapPackNum
					deleteMapFolder(this.curCarId,mapPackNum).then(res =>{					
						if(res.result==="0"){
							this.$message({
									message: res.message,
									type: 'success'
							})							  
						}else{
							this.$message.error(res.message)
						}
					})
				})
			}
		}
	}
	
</script>

<style>
</style>
